module.exports = __webpack_public_path__ + "img/27_21.7de211b3.png";